<template lang="pug">
v-row
  v-col.pt-0.pb-0(cols="12")
    v-text-field(
      :value="formData.name"
      @input="$emit('update', {field: 'name',val: $event})"
      label="Name"
      :error="formErrors.hasError('name')"
      :error-messages="formErrors.fields.name"
    )
  v-col.pt-0.pb-0(cols="12")
    v-text-field(
      :value="formData.number"
      @input="$emit('update', {field: 'number',val: $event})"
      label="Number"
      :error="formErrors.hasError('number')"
      :error-messages="formErrors.fields.number"
    )
  v-col.pt-0.pb-0(cols="12")
    v-text-field(
      :value="formData.slug"
      @input="$emit('update', {field: 'slug',val: $event})"
      label="Slug"
      :error="formErrors.hasError('slug')"
      :error-messages="formErrors.fields.slug"
    )

</template>

<script>
import {mapActions} from "vuex"
export default {
  name: 'ExamBody',
  props: {
    formData: Object,
    formErrors: Object,
  },

}
</script>
